'use strict';
; (function () {
    angular.module("EMR.AddOrEditDisplaySequenceForCommonTestsPopupModule", []);

    var AddOrEditDisplaySequenceForCommonTestsPopupModuleRoutes = [
        {
            "state": false,
            "name": "emrAddOrEditDisplaySequenceForCommonTestsPopup",
            "url": "emrAddOrEditDisplaySequenceForCommonTestsPopup",
            "RoutingNumber": 4586,
            templateUrl: "AngularScripts/AddOrEditDisplaySequenceForCommonTests/Htmls/AddOrEditDisplaySequenceForCommonTestsPopup.html",
            files: [
                "AngularScripts/Validations/Directives/FieldValidationForSignedDecimalWithOptionalRangeDirective.js",
                "AngularScripts/AddOrEditDisplaySequenceForCommonTests/Controllers/AddOrEditDisplaySequenceForCommonTestsPopupController.js",
               
            ]
        },

    ]

    angular.module('EMR.AddOrEditDisplaySequenceForCommonTestsPopupModule')
        .constant("AddOrEditDisplaySequenceForCommonTestsPopupModuleRoutes", AddOrEditDisplaySequenceForCommonTestsPopupModuleRoutes)
        .config(["$stateProvider", "EmrRouteProvider", "AddOrEditDisplaySequenceForCommonTestsPopupModuleRoutes",
            function ($stateProvider, EmrRouteProvider, AddOrEditDisplaySequenceForCommonTestsPopupModuleRoutes) {
                EmrRouteProvider.registerStates(AddOrEditDisplaySequenceForCommonTestsPopupModuleRoutes, $stateProvider);
            }]);
})();
